import React from 'react';
import { CardDetailCourse } from './CardDetailCourse';
import { formatDateTime } from '../../common/formatDateText';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import {
    getAllRequest,
    requestAddStudentApproved,
    requestDeleteStudentApproved,
} from '../../redux/actions/request';
import {
    getTotalRequestStudentsPending
} from '../../redux/actions/analytics';

export const CardRequestStudentUpdate = ({
    id,
    student,
    numberRequest,
    approvedBy,
    requestBy,
    requestDate,
    requestType,
    requestStatus,
    courses,
    setFilterOption
}) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.user);

    const { _id: userId, typeUser } = user;

    const allowedRoles = ['admin', 'director'];

    const handleConfirm = (id, requestType) => {
        const actionsMap = {
            add: requestAddStudentApproved,
            delete: requestDeleteStudentApproved,
        };

        const action = actionsMap[requestType];
        if (!action) return;

        dispatch(action(id, userId))
            .then((response) => {
                if (response?.status === 200) {
                    toast.success(response?.message);
                    setFilterOption('pending');
                    dispatch(getAllRequest());
                    dispatch(getTotalRequestStudentsPending('pending'));
                }
            })
            .catch((error) => {
                toast.error(error);
            });
    };

    return (
        <div className='w-full border border-gray-200 rounded-md shadow-sm bg-white'>
            <div className='w-full flex justify-between items-center p-4'>
                <div>
                    <p className='pt-2 px-1 text-[.9rem] font-semibold'>{`Solicitud #${numberRequest}`}</p>
                </div>
                <div>
                    <span className={`${requestStatus === 'done' ? 'bg-green-200' : requestStatus === 'pending' ? 'bg-orange-200' : 'bg-red-200'} rounded-md px-2.5 py-1.5 text-[.7rem]`}>
                        {
                            requestStatus === "pending"
                                ? <span className='text-orange-600'>Pendiente</span> : requestStatus === "done"
                                    ? <span className='text-green-600'>Completada</span> : <span className='text-red-500'>Rechazada</span>
                        }
                    </span>
                </div>
            </div>
            <div className='w-full flex flex-col gap-4 p-4'>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Tipo de de solicitud</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>{
                        requestType === "add"
                            ? "Agregar" : requestType === "update"
                                ? "Actualizar" : "Eliminar"
                    }</span>
                </div>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Solicitado por</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>
                        {`${requestBy?.firstName} ${requestBy?.secondName ? requestBy?.secondName : ''} ${requestBy?.lastName} ${requestBy?.secondSurname ? requestBy?.secondSurname : ''}`}
                    </span>
                </div>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Datos del estudiante</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>{
                        `[ ${student?.matricula} ]`
                    }</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>{
                        `${student?.firstName} ${student?.secondName ? student?.secondName : ''} ${student?.lastName} ${student?.secondSurname ? student?.secondSurname : ''}`
                    }</span>
                </div>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Aprobada por</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>
                        {approvedBy ? `${approvedBy?.firstName} ${approvedBy?.secondName ? approvedBy?.secondName : ''} ${approvedBy?.lastName} ${approvedBy?.secondSurname ? approvedBy?.secondSurname : ''}` : '-'}
                    </span>
                </div>
                <div className='flex flex-col justify-center items-center p-4 rounded-md bg-slate-100 shadow-sm'>
                    <span className='font-normal text-[.7rem] text-gray-600 leading-6'>Fecha de solicitud</span>
                    <span className='text-slate-800 font-semibold text-[.8rem] tracking-wide uppercase text-center'>{formatDateTime(requestDate)}</span>
                </div>
            </div>
            <div className='w-full flex flex-col md:flex-row justify-center items-center gap-2'>
                {
                    (requestType && (requestType === "add" || requestType === 'delete')) && (
                        <>
                            <div className='w-full flex flex-col justify-center items-center p-4 rounded-md'>
                                <div className='w-full flex justify-center items-center mb-4'>
                                    <span className='text-slate-800 font-semibold text-[1rem] tracking-wide uppercase'>Curso</span>
                                </div>

                                <CardDetailCourse
                                    course={courses[0]}
                                />
                            </div>
                        </>
                    )
                }
            </div>
            {
                (requestStatus === 'pending' && allowedRoles.includes(typeUser)) && (
                    <div className='w-full flex flex-col md:flex-row justify-end p-4 gap-4'>
                        <button
                            type='button'
                            onClick={() => handleConfirm(id, requestType)}
                            className='rounded-md font-semibold text-md text-white bg-indigo-600 hover:bg-indigo-700 px-4 py-2'
                        >Confirmar</button>
                    </div>
                )
            }
        </div>

    )
}
